var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "margin-y-3 margin-x-10" },
    [
      _c(
        "h1",
        {
          staticClass: "margin-y-4",
          staticStyle: {
            "text-transform": "uppercase",
            "font-weight": "700",
            "letter-spacing": "1px",
            "font-size": "30px",
          },
        },
        [_vm._v("Create a new campaign")]
      ),
      _vm._v(" "),
      _c("campaign-form", {
        ref: "campaignForm",
        attrs: { campaign: _vm.campaign },
        scopedSlots: _vm._u([
          {
            key: "action-buttons",
            fn: function () {
              return [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary btn-md",
                    attrs: {
                      click: () => {
                        return _vm.createCampaign("edit")
                      },
                    },
                  },
                  [_vm._v("Create & Add Requests")]
                ),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-md",
                    attrs: {
                      click: () => {
                        return _vm.createCampaign("drafts")
                      },
                    },
                  },
                  [_vm._v("Save as draft")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }